export var API_BASE_URL = 'https://lecta.ru/payment/api/v1/'
export var API_BASE_URL_DEV = 'https://dev.lecta.ru/payment/api/v1/'
